import { FC } from 'react';
import { LoadingModal } from 'src/components/LoadingModal';
import { DeleteDeviceModal } from 'src/features/device/common';
import { RestartDeviceModal } from 'src/features/device/common';
import { DeleteInteractionModal } from 'src/features/interaction/common';
import { DeleteInteractionDictionaryModal } from 'src/features/interaction-dictionary/common';
import { DeleteThemeModal } from 'src/features/theme/common';
import { DeleteCampaignModal } from 'src/features/campaign/common';
import { DeleteCampaignSlotModal } from 'src/features/campaign/common/DeleteCampaignSlotModal';
import { DeleteBrandingModal } from 'src/features/branding/common';

export const GlobalModals: FC = () => {
  return (
    <>
      <DeleteDeviceModal />
      <RestartDeviceModal />
      <LoadingModal />
      <DeleteInteractionModal />
      <DeleteInteractionDictionaryModal />
      <DeleteThemeModal />
      <DeleteBrandingModal />
      <DeleteCampaignModal />
      <DeleteCampaignSlotModal />
    </>
  );
};
